module.exports = __webpack_public_path__ + "media/images/emblems/Gerzensee-coat_of_arms-02e84ff959171dd78cccc7384134cbd3.svg";